// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1032":"94505f3c","3538":"3e8900b3","3590":"a267ace2","7768":"4763b654"}[chunkId] + ".chunk.css";
};